var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleDocs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 280",
    enableBackground: "new 0 0 300 280",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#557EBF",
    d: "M170.86,25.24H82.18c-8.34,0-15.64,7.3-15.64,15.65V239.1c0,8.34,7.3,15.65,15.65,15.65h135.62 c8.34,0,15.65-7.3,15.65-15.65V87.83l-36.51-26.08L170.86,25.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M108.26,192.16h83.46v-10.43h-83.45L108.26,192.16L108.26,192.16z M108.26,213.02h62.59V202.6h-62.59 V213.02z M108.26,140v10.43h83.46V140H108.26z M108.26,171.29h83.46v-10.43h-83.45L108.26,171.29L108.26,171.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6C0E4",
    d: "M170.86,25.24v46.95c0,8.34,7.3,15.64,15.64,15.64h46.95L170.86,25.24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDocs);
export default __webpack_public_path__ + "static/media/google-docs.43f77837bfe20ff2ef3fedb415e54ac9.svg";
export { ForwardRef as ReactComponent };